var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cookiesOpen && _vm.goodMarket)?_c('div',{staticClass:"ev-cookie-banner",class:{
    'mobile': _vm.isMobile
  }},[_c('div',{staticClass:"ev-cookie-banner_text",domProps:{"innerHTML":_vm._s(_vm.cookies)},on:{"click":_vm.openPrivacyLink}}),_c('RoundClose',{on:{"click":_vm.closeCookies}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }